import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User } from 'src/app/models';
import { UserInfoResult } from 'src/app/services';
import { environment } from 'src/environments/environment.local';

import { IUserApi } from './interfaces/user-abastract.api';

@Injectable({
  providedIn: 'root',
})
export class UserApi implements IUserApi {
  constructor(private readonly http: HttpClient) { }

  getSharablePlatform(): Observable<string[]> {
    const url: string = environment.api.trainingLog.getSharablePlatforms;
    return this.http.get(url).pipe(
      map((data: { data: { platform: string }[] }) => {
        return data.data.map((platform) => platform.platform);
      })
    );
  }

  getUser(): Observable<User> {
    return this.http
      .get<UserInfoResult>(environment.api.me)
      .pipe(map<UserInfoResult, User>(({ data }: { data: User }) => data));
  }

  getUserById(id: number): Observable<User> {
    const url: string = environment.api.externalUser.information.replace(
      '{userId}',
      id.toString()
    );
    return this.http.get(url).pipe(
      map((item: any) => {
        return item.data;
      })
    );
  }
}
